import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Lang from 'types/Lang';

const LANGUAGES = [Lang.nl, Lang.fr, Lang.en];

/**
 * Plain buttons rather than a dropdown: one tap on a phone. The active language also decides the
 * LanguageId sent on submit.
 */
const LanguageSwitcher = (): JSX.Element => {
  // Read off the live instance, not into state: the page detects the locale in an effect that runs
  // after this child mounts, so a captured value would highlight the wrong language.
  const [, i18n] = useTranslation();
  // Tolerates a regional tag ('nl-BE') as well as the bare code the switcher itself sets.
  const active = (i18n.language ?? '').slice(0, 2).toLowerCase();

  return (
    <Box sx={{ display: 'flex', gap: '4px', alignSelf: 'flex-end', marginBottom: '8px' }}>
      {LANGUAGES.map(language => (
        <Button
          key={language}
          onClick={() => i18n.changeLanguage(language)}
          size="small"
          sx={{ minWidth: '40px', textTransform: 'uppercase', fontWeight: active === language ? 700 : 400 }}
        >
          {language}
        </Button>
      ))}
    </Box>
  );
};

export default LanguageSwitcher;
